module.exports = __webpack_public_path__ + "img/nie.6a56f7b3.jpg";